module.exports = __webpack_public_path__ + "img/logo.f70944aa.png";